var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ToolkitConstants } from "../toolkit.config";
import { getContentConfig, getServerConfig, processIncludedForChildParagraphs, } from "../utils/index";
/**
 * @function parseJsonResponseMetadata
 * @description **parses the JSON response of the content type, to get non-reference type content.**
 * - the metadata like browser tab title or page level configurations are non-reference type content.
 * - the paragraph content are not included in the metadata.
 * @param {object} initialContentFromCMS - JSON response from the CMS.
 * @param {number} currentIndex - index of the content in the JSON response.
 * @param {string[]} contentNonRefFields - array of non reference type manchine names of content type.
 * @param {string[]} contentMediaFields - array of media type manchine names of content type.
 * @param {string[]} contextTaxonomyFields - array of taxonomy type manchine names of content type.
 * @returns {Promise<object>} promise of object of paragraphs, used in content.
 */
export const parseJsonResponseMetadata = (initialContentFromCMS, currentIndex = 0, contentNonRefFields, contentMediaFields, contextTaxonomyFields) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e;
    const attributes = (_a = (initialContentFromCMS.data instanceof Array
        ? initialContentFromCMS.data[currentIndex].attributes
        : initialContentFromCMS.data.attributes)) !== null && _a !== void 0 ? _a : {};
    const relationships = (_b = (initialContentFromCMS.data instanceof Array
        ? initialContentFromCMS.data[currentIndex].relationships
        : initialContentFromCMS.data.relationships)) !== null && _b !== void 0 ? _b : {};
    let processedPageData = {};
    const processedMetaTags = {};
    const processedTaxonomy = {};
    contentNonRefFields === null || contentNonRefFields === void 0 ? void 0 : contentNonRefFields.forEach((contentNonRefField) => {
        processedPageData[contentNonRefField] = attributes[contentNonRefField];
    });
    for (const contentMediaField of contentMediaFields) {
        if ((initialContentFromCMS === null || initialContentFromCMS === void 0 ? void 0 : initialContentFromCMS.data) instanceof Array) {
            const metaMediaObject = yield parseMediaElements({
                id: "",
                type: "",
                attributes: {},
                relationships: (_c = initialContentFromCMS === null || initialContentFromCMS === void 0 ? void 0 : initialContentFromCMS.data[currentIndex]) === null || _c === void 0 ? void 0 : _c.relationships,
            }, contentMediaField, (initialContentFromCMS === null || initialContentFromCMS === void 0 ? void 0 : initialContentFromCMS.included) ? initialContentFromCMS === null || initialContentFromCMS === void 0 ? void 0 : initialContentFromCMS.included : []);
            if (metaMediaObject === null || metaMediaObject === void 0 ? void 0 : metaMediaObject.hasOwnProperty(contentMediaField)) {
                processedPageData[contentMediaField] = metaMediaObject[contentMediaField];
            }
        }
    }
    if (attributes[ToolkitConstants.MACHINENAME_METATAG] instanceof Array) {
        const metaTags = attributes[ToolkitConstants.MACHINENAME_METATAG];
        metaTags === null || metaTags === void 0 ? void 0 : metaTags.forEach((metaTag) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            processedMetaTags[`${ToolkitConstants.MACHINENAME_METATAG_PREFIX}_${(_d = (_b = (_a = metaTag === null || metaTag === void 0 ? void 0 : metaTag.attributes) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : (_c = metaTag === null || metaTag === void 0 ? void 0 : metaTag.attributes) === null || _c === void 0 ? void 0 : _c.rel) !== null && _d !== void 0 ? _d : (_e = metaTag === null || metaTag === void 0 ? void 0 : metaTag.attributes) === null || _e === void 0 ? void 0 : _e.property}`] = (_j = (_g = (_f = metaTag === null || metaTag === void 0 ? void 0 : metaTag.attributes) === null || _f === void 0 ? void 0 : _f.content) !== null && _g !== void 0 ? _g : (_h = metaTag === null || metaTag === void 0 ? void 0 : metaTag.attributes) === null || _h === void 0 ? void 0 : _h.href) !== null && _j !== void 0 ? _j : "";
        });
    }
    const taxonomyArray = [];
    for (const contextTaxonomyField of contextTaxonomyFields) {
        const taxonomyData = (_d = relationships[contextTaxonomyField]) === null || _d === void 0 ? void 0 : _d.data;
        (_e = initialContentFromCMS === null || initialContentFromCMS === void 0 ? void 0 : initialContentFromCMS.included) === null || _e === void 0 ? void 0 : _e.forEach((includedRecord) => {
            var _a, _b;
            const taxonomyObject = !(taxonomyData instanceof Array)
                ? taxonomyData
                : { id: "", type: "" };
            if ((taxonomyObject === null || taxonomyObject === void 0 ? void 0 : taxonomyObject.id) === includedRecord.id &&
                (taxonomyObject === null || taxonomyObject === void 0 ? void 0 : taxonomyObject.type) === includedRecord.type) {
                const taxonomyName = ((_a = includedRecord === null || includedRecord === void 0 ? void 0 : includedRecord.attributes) === null || _a === void 0 ? void 0 : _a.name) || "";
                const taxonomyStatus = ((_b = includedRecord === null || includedRecord === void 0 ? void 0 : includedRecord.attributes) === null || _b === void 0 ? void 0 : _b.status) || false;
                if (taxonomyStatus) {
                    processedTaxonomy[contextTaxonomyField] =
                        typeof taxonomyName === "string" ? taxonomyName : "";
                }
            }
        });
    }
    taxonomyArray === null || taxonomyArray === void 0 ? void 0 : taxonomyArray.forEach((taxonomy) => {
        var _a;
        (_a = initialContentFromCMS === null || initialContentFromCMS === void 0 ? void 0 : initialContentFromCMS.included) === null || _a === void 0 ? void 0 : _a.forEach((includedRecord) => {
            var _a, _b;
            if ((taxonomy === null || taxonomy === void 0 ? void 0 : taxonomy.id) === includedRecord.id &&
                (taxonomy === null || taxonomy === void 0 ? void 0 : taxonomy.type) === includedRecord.type) {
                const taxonomyName = ((_a = includedRecord === null || includedRecord === void 0 ? void 0 : includedRecord.attributes) === null || _a === void 0 ? void 0 : _a.name) || "";
                const taxonomyStatus = ((_b = includedRecord === null || includedRecord === void 0 ? void 0 : includedRecord.attributes) === null || _b === void 0 ? void 0 : _b.status) || false;
                if (taxonomyStatus) {
                    processedTaxonomy[taxonomy === null || taxonomy === void 0 ? void 0 : taxonomy.type] =
                        typeof taxonomyName === "string" ? taxonomyName : "";
                }
            }
        });
    });
    processedPageData = Object.assign(Object.assign(Object.assign({}, processedPageData), processedMetaTags), processedTaxonomy);
    return processedPageData;
});
/**
 * @function parseJsonResponseIncludedElements
 * @description **parses the JSON response for the content and media.**
 * - the paragraphs used in the content are processed.
 * - the media used in the paragraphs are processed.
 * @param {object[]} included - array of included elements from JSON response.
 * @param {object[]} usedParas - array of paragraphs used in the content.
 * @returns {Promise<object[]>} promise of array of paragraphs content with media endpoint, used in content.
 */
export const parseJsonResponseIncludedElements = (included, usedParas) => __awaiter(void 0, void 0, void 0, function* () {
    var _f;
    const contentConfig = yield getContentConfig();
    const paragraphsConfig = contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.paragraphs;
    const processedParagraphData = [];
    for (const usedPara of usedParas) {
        const cleanedParagraphType = ((_f = usedPara === null || usedPara === void 0 ? void 0 : usedPara.type) === null || _f === void 0 ? void 0 : _f.split("--")[1]) || (usedPara === null || usedPara === void 0 ? void 0 : usedPara.type);
        const paragraphMachineNameConfig = paragraphsConfig[cleanedParagraphType];
        if (!paragraphMachineNameConfig)
            continue;
        const paraType = usedPara.type;
        const paraId = usedPara.id;
        const machineNames = paragraphMachineNameConfig.machineNames;
        const processedPara = yield processConfigMachineNames(paraType, paraId, machineNames, included);
        processedParagraphData.push(Object.assign({ type: cleanedParagraphType }, processedPara));
    }
    return processedParagraphData;
});
/**
 * @function processConfigMachineNames
 * @description **processes the machine names used in a paragraph.**
 * - the machine names are the field identifiers used in the paragraph.
 * - the machine names are used to extract the content or media from the JSON response.
 * @param {string} paraType - type of the paragraph.
 * @param {string} paraId - id of the paragraph from JSON response.
 * @param {object[]} machineNamesConfig - array of machine names used in the paragraph.
 * @param {object[]} included - array of included elements from JSON response.
 * @returns {Promise<object>} promise of object of processed machine names and associated content or media.
 */
export const processConfigMachineNames = (paraType, paraId, machineNamesConfig, included) => __awaiter(void 0, void 0, void 0, function* () {
    let processedData = {};
    for (const machineNameConfig of machineNamesConfig) {
        const isMediaType = machineNameConfig.isMediaType;
        const isReferenceType = machineNameConfig.isReferenceType;
        if (isReferenceType) {
            const childParaContents = yield parseChildParagraphs(paraType, paraId, machineNameConfig.machineName, included);
            processedData = Object.assign(Object.assign({}, processedData), childParaContents);
            continue;
        }
        const mediaData = yield extractIndividualContentElement(paraType, paraId, machineNameConfig.machineName, isMediaType, included);
        if (typeof mediaData === "object")
            processedData = Object.assign(Object.assign({}, processedData), mediaData);
    }
    return processedData;
});
/**
 * @function parseChildParagraphs
 * @description **parses the child paragraphs used in a paragraph.**
 * - the child paragraphs are the paragraphs used in the paragraph.
 * - the child paragraphs are used to extract the content or media from the JSON response.
 * @param {string} parentParaType - type of the parent paragraph.
 * @param {string} parentParaId - id of the parent paragraph from JSON response.
 * @param {string} machineName - machine name used in paragraph.
 * @param {object[]} included - array of included elements from JSON response.
 * @returns {Promise<object>} promise of object of processed child paragraphs and associated content or media.
 */
export const parseChildParagraphs = (parentParaType, parentParaId, machineName, included) => __awaiter(void 0, void 0, void 0, function* () {
    const usedChildParas = processIncludedForChildParagraphs(parentParaType, parentParaId, machineName, included);
    const childParaContent = yield parseJsonResponseIncludedElements(included, usedChildParas);
    return { [machineName]: childParaContent };
});
/**
 * @function extractIndividualContentElement
 * @description **extracts the machine name specific content from the JSON response.**
 * - the machine names are the field identifiers used in the paragraph.
 * - the machine names are used to extract the content or media from the JSON response.
 * - it checks for media type and prepares the media object response for toolkit.
 * @param {string} paraType - type of the paragraph.
 * @param {string} paraId - id of the paragraph from JSON response.
 * @param {string} machineName - machine name used in paragraph.
 * @param {boolean} isMediaType - boolean to check if the machine name is of media type.
 * @param {object[]} included - array of included elements from JSON response.
 * @returns {Promise<object>} promise of object of processed machine name to extract media.
 */
export const extractIndividualContentElement = (paraType, paraId, machineName, isMediaType, included) => __awaiter(void 0, void 0, void 0, function* () {
    let paraRecord;
    included === null || included === void 0 ? void 0 : included.forEach((include) => {
        if (include.type.endsWith(paraType) && include.id === paraId) {
            paraRecord = {
                id: include.id,
                type: include.type,
                attributes: include.attributes,
                relationships: include.relationships,
            };
        }
    });
    if ((paraRecord === null || paraRecord === void 0 ? void 0 : paraRecord.attributes) && !isMediaType) {
        return { [machineName]: paraRecord.attributes[machineName] };
    }
    if (paraRecord && isMediaType) {
        return yield parseMediaElements(paraRecord, machineName, included);
    }
    return {};
});
/**
 * @function parseMediaElements
 * @description **parses the media elements from the JSON response.**
 * - the media elements are the media used in the paragraph.
 * @param {object} paraRecord - JSON response of the paragraph.
 * @param {string} machineName - machine name used in paragraph.
 * @param {object[]} included - array of included elements from JSON response.
 * @returns {Promise<object>} promise of object of processed media elements.
 */
export const parseMediaElements = (paraRecord, machineName, included) => __awaiter(void 0, void 0, void 0, function* () {
    var _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    if (((_h = (_g = paraRecord === null || paraRecord === void 0 ? void 0 : paraRecord.relationships) === null || _g === void 0 ? void 0 : _g[machineName]) === null || _h === void 0 ? void 0 : _h.data) instanceof Array) {
        return;
    }
    const mediaId = (_l = (_k = (_j = paraRecord === null || paraRecord === void 0 ? void 0 : paraRecord.relationships) === null || _j === void 0 ? void 0 : _j[machineName]) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.id;
    const mediaType = (_p = (_o = (_m = paraRecord === null || paraRecord === void 0 ? void 0 : paraRecord.relationships) === null || _m === void 0 ? void 0 : _m[machineName]) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.type;
    let mediaRecord;
    let actualMediaId = "";
    let imageAlt = "";
    included === null || included === void 0 ? void 0 : included.forEach((record) => {
        if ((record === null || record === void 0 ? void 0 : record.type) === mediaType && (record === null || record === void 0 ? void 0 : record.id) === mediaId) {
            mediaRecord = record;
        }
    });
    if ((mediaRecord === null || mediaRecord === void 0 ? void 0 : mediaRecord.type) === (ToolkitConstants === null || ToolkitConstants === void 0 ? void 0 : ToolkitConstants.MACHINENAME_TYPE_REMOTE_VIDEO)) {
        return {
            [machineName]: {
                [ToolkitConstants.MACHINENAME_REMOTE_VIDEO]: mediaRecord === null || mediaRecord === void 0 ? void 0 : mediaRecord.attributes[ToolkitConstants === null || ToolkitConstants === void 0 ? void 0 : ToolkitConstants.MACHINENAME_REMOTE_VIDEO],
                name: (_q = mediaRecord === null || mediaRecord === void 0 ? void 0 : mediaRecord.attributes) === null || _q === void 0 ? void 0 : _q.name,
            },
        };
    }
    if (mediaRecord) {
        const relationships = mediaRecord === null || mediaRecord === void 0 ? void 0 : mediaRecord.relationships;
        if (relationships[ToolkitConstants === null || ToolkitConstants === void 0 ? void 0 : ToolkitConstants.MACHINENAME_IMAGE]) {
            imageAlt = (_t = (_s = (_r = relationships[ToolkitConstants === null || ToolkitConstants === void 0 ? void 0 : ToolkitConstants.MACHINENAME_IMAGE]) === null || _r === void 0 ? void 0 : _r.data) === null || _s === void 0 ? void 0 : _s.meta) === null || _t === void 0 ? void 0 : _t.alt;
            actualMediaId = (_v = (_u = relationships[ToolkitConstants === null || ToolkitConstants === void 0 ? void 0 : ToolkitConstants.MACHINENAME_IMAGE]) === null || _u === void 0 ? void 0 : _u.data) === null || _v === void 0 ? void 0 : _v.id;
        }
        if (relationships[ToolkitConstants === null || ToolkitConstants === void 0 ? void 0 : ToolkitConstants.MACHINENAME_AUDIO]) {
            actualMediaId = (_x = (_w = relationships[ToolkitConstants === null || ToolkitConstants === void 0 ? void 0 : ToolkitConstants.MACHINENAME_AUDIO]) === null || _w === void 0 ? void 0 : _w.data) === null || _x === void 0 ? void 0 : _x.id;
        }
        if (relationships[ToolkitConstants === null || ToolkitConstants === void 0 ? void 0 : ToolkitConstants.MACHINENAME_VIDEO]) {
            actualMediaId = (_z = (_y = relationships[ToolkitConstants === null || ToolkitConstants === void 0 ? void 0 : ToolkitConstants.MACHINENAME_VIDEO]) === null || _y === void 0 ? void 0 : _y.data) === null || _z === void 0 ? void 0 : _z.id;
        }
        if (relationships[ToolkitConstants === null || ToolkitConstants === void 0 ? void 0 : ToolkitConstants.MACHINENAME_DOCUMENT]) {
            actualMediaId = (_1 = (_0 = relationships[ToolkitConstants === null || ToolkitConstants === void 0 ? void 0 : ToolkitConstants.MACHINENAME_DOCUMENT]) === null || _0 === void 0 ? void 0 : _0.data) === null || _1 === void 0 ? void 0 : _1.id;
        }
    }
    if (!mediaId) {
        return {};
    }
    const mediaData = yield parseMediaEndpoints(actualMediaId, machineName, included, imageAlt);
    return mediaData;
});
/**
 * @function parseMediaEndpoints
 * @description **parses the media endpoints from the JSON response.**
 * - the media endpoints are the media used in the paragraph.
 * - the absolute endpoint gets generated.
 * @param {string} actualMediaId - id of the media.
 * @param {string} machineName - machine name used in paragraph.
 * @param {object[]} included - array of included elements from JSON response.
 * @param {string} imageAlt -`optional` alt text of the image.
 * @returns {Promise<object>} promise of object of processed media endpoints.
 */
export const parseMediaEndpoints = (actualMediaId, machineName, included, imageAlt) => __awaiter(void 0, void 0, void 0, function* () {
    var _2, _3, _4, _5, _6;
    let mediaData;
    const serverConfig = yield getServerConfig();
    const drupalFileserverUrl = ((_2 = serverConfig.DRUPAL_FILE_SERVER_URL) === null || _2 === void 0 ? void 0 : _2.endsWith("/"))
        ? (_3 = serverConfig.DRUPAL_FILE_SERVER_URL) === null || _3 === void 0 ? void 0 : _3.slice(0, -1)
        : (_4 = serverConfig.DRUPAL_FILE_SERVER_URL) !== null && _4 !== void 0 ? _4 : null;
    const drupalServerUrl = ((_5 = serverConfig.DRUPAL_SERVER_URL) === null || _5 === void 0 ? void 0 : _5.endsWith("/"))
        ? (_6 = serverConfig.DRUPAL_SERVER_URL) === null || _6 === void 0 ? void 0 : _6.slice(0, -1)
        : serverConfig.DRUPAL_SERVER_URL;
    if (!machineName)
        return;
    included === null || included === void 0 ? void 0 : included.forEach((mediaElement) => {
        var _a, _b, _c, _d, _e, _f, _g;
        if ((mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.type) === "file--file" &&
            (mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.id) === actualMediaId) {
            mediaData = {
                [machineName]: {
                    alt: imageAlt,
                    mimetype: (_a = mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.attributes) === null || _a === void 0 ? void 0 : _a.filemime,
                    url: `${drupalFileserverUrl !== null && drupalFileserverUrl !== void 0 ? drupalFileserverUrl : drupalServerUrl}${typeof ((_b = mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.attributes) === null || _b === void 0 ? void 0 : _b.uri) !== "string" &&
                        typeof ((_c = mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.attributes) === null || _c === void 0 ? void 0 : _c.uri) !== "boolean" &&
                        typeof ((_d = mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.attributes) === null || _d === void 0 ? void 0 : _d.uri) !== "number" &&
                        !(((_e = mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.attributes) === null || _e === void 0 ? void 0 : _e.uri) instanceof Array) &&
                        ((_g = (_f = mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.attributes) === null || _f === void 0 ? void 0 : _f.uri) === null || _g === void 0 ? void 0 : _g.url)}`,
                },
            };
        }
    });
    return mediaData;
});
/**
 * @function parseJsonSecondaryResponseMenu
 * @description **parses the JSON response for sub menu.**
 * - sub menu are the menu items with hierarchy level 2.
 * - JSON module is not used to fetch menu.
 * @param {object[]} menuItems - JSON response for menu.
 * @param {string} menuOrderId  - order id of the menu.
 * @returns {object[]} array of menu items.
 */
export const parseJsonSecondaryResponseMenu = (menuItems, menuOrderId) => {
    const processedMenuItems = [];
    menuItems === null || menuItems === void 0 ? void 0 : menuItems.forEach((menuItem) => {
        var _a, _b;
        if (+menuItem.hierarchy.length === 2 &&
            +menuItem.hierarchy[0] === +menuOrderId) {
            const processedMenuItem = {
                title: menuItem.title,
                href: menuItem.href,
                class: (_a = menuItem === null || menuItem === void 0 ? void 0 : menuItem.class) === null || _a === void 0 ? void 0 : _a.join(" "),
                target: (_b = menuItem === null || menuItem === void 0 ? void 0 : menuItem.target) === null || _b === void 0 ? void 0 : _b[0],
                submenu: [],
            };
            processedMenuItems.push(processedMenuItem);
        }
    });
    return processedMenuItems;
};
/**
 * @function parseJsonTopLevelResponseMenu
 * @description **parses the JSON response for menu.**
 * - top level menu are the menu items with hierarchy level 1.
 * - JSON module is not used to fetch menu.
 * @param {object} menuJsonResponse - JSON response for menu.
 * @returns {object[]} array of menu items.
 */
export const parseJsonTopLevelResponseMenu = (menuJsonResponse) => {
    const menuItems = menuJsonResponse.linkset[0].item;
    const processedMenuItems = [];
    menuItems === null || menuItems === void 0 ? void 0 : menuItems.forEach((menuItem) => {
        var _a, _b;
        if (+menuItem.hierarchy.length === 1) {
            const processedMenuItem = {
                title: menuItem.title,
                href: menuItem === null || menuItem === void 0 ? void 0 : menuItem.href,
                class: (_a = menuItem === null || menuItem === void 0 ? void 0 : menuItem.class) === null || _a === void 0 ? void 0 : _a.join(" "),
                target: (_b = menuItem.target) === null || _b === void 0 ? void 0 : _b[0],
                submenu: parseJsonSecondaryResponseMenu(menuItems, menuItem.hierarchy[0]),
            };
            processedMenuItems.push(processedMenuItem);
        }
    });
    return processedMenuItems;
};
